import { Loader } from "components/Common/Loader";
import { ShowStatus } from "components/Common/ShowStatus";
import TransactionType from "components/Common/TopupHistory/TransactionType";
import { useEffect, useMemo } from "react";

const DesktopTable = ({
  historyDetailsList,
  headerList,
  loading,
  fetchData,
  businessID,
  hasMoreData,
}: topUpHistoryProps) => {
  useEffect(() => {
    document.body.classList.add("overflow-y-hidden");
    return () => {
      document.body.classList.add("overflow-y-scroll");
    };
  }, []);

  const debitTransactions = useMemo(() => ["PO", "EA"], [historyDetailsList]);

  return (
    <div className="bg-offWhite flexflex-col max-h-[80vh] overflow-scroll relative no-scrollbar">
      {/* //Bottom TABLE// */}
      <div className="bg-white  list relative ">
        <table className="w-full min-w-max table-fixed text-left bg-lightPrimary">
          <thead className="sticky bg-white top-0 ">
            <tr>
              {headerList?.map((head) => (
                <th
                  key={head}
                  className="border-b border-blue-gray-100 bg-lightBlue p-4"
                >
                  <h2
                    color="blue-gray"
                    className="font-normal leading-none opacity-70"
                  >
                    {head}
                  </h2>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="list-inner">
            {historyDetailsList?.map(
              ({ transactionID, amount, date, status, type }, index) => {
                const isLast = index === historyDetailsList.length - 1;
                const classes = isLast
                  ? "p-4"
                  : "p-4 border-b border-blue-gray-50";

                return (
                  <tr key={transactionID}>
                    <td className={classes}>
                      <h2>{transactionID}</h2>
                    </td>
                    <td className={classes}>
                      <h2 color="blue-gray" className="font-normal">
                        {debitTransactions.includes(type) ? "-" : ""}${amount}
                      </h2>
                    </td>
                    <td className={classes}>
                      <h2 color="blue-gray" className="font-normal">
                        {date}
                      </h2>
                    </td>
                    <td className={classes}>
                      <TransactionType type={type} />
                    </td>
                    <td className={classes}>
                      {" "}
                      <ShowStatus status={status} />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
        {!loading && hasMoreData && (
          <div className="flex  items-center justify-center ">
            <button
              type={"button"}
              onClick={() => {
                fetchData(businessID);
              }}
              disabled={false}
              className={`text-black  w-25  font-medium rounded-lg text-l  py-2.5 px-2 mt-2 mb-2`}
            >
              {" "}
              <div className="flex flex-row gap-2">Load more</div>
            </button>
          </div>
        )}
        {loading && (
          <div className="flex w-full mt-2 mb-2 items-center justify-center">
            <Loader size={6} color="darkBlue" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopTable;
